import { FilterOption } from '../../../components/_WMS/FilterComponent'

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'courierName',
    label: 'Courier',
    type: 'text'
  },
  {
    order: 2,
    key: 'courierServiceName',
    label: 'Servicio de Courier',
    type: 'text'
  }
]
